<template>
  <hic-dialog v-loading="meta.loading" :title="title" :visible="visible" @close="cancel" @open="open" width="80%"
    top="10vh">
    <el-main style="padding: 5px 20px">      
      <el-form class="left top-pad" ref="editInfo" :rules="rules" :inline="true" :model="editInfo" label-width="8rem">
        <el-row>
          <el-col :span="8">
            <el-form-item label="请选择患者：" prop="bedNo">
              <el-select v-model="editInfo.bedNo" value-key="id" placeholder="请选择患者" @change="handlePatientChange" clearable size="small" class="right-pad inputwidth" filterable>
                <el-option v-for="item in patientList" :key="item.id" :label="`${item.bedNo}：${item.patientName}`" :value="item.bedNo" style="height: 3rem">
                  <el-badge :value="item.news" :hidden="!item.news" style="margin: 0.5rem 0">
                    <el-tag size="small" :type="item.news > 0 ? 'danger' : 'info'" class="right-pad">{{ item.bedNo }}</el-tag>
                  </el-badge>

                  <b>{{ item.patientName }}</b>
                  <span>{{ item.patientGender | dictText("Gender") }} {{ item.patientAge }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类型：" prop="type">
              <hic-text-selector dict-type="OutType" is-enum v-model="editInfo.type" class=" inputwidth"
                placeholder="请选择"></hic-text-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="办案单位：" prop="caseUnit">
              <el-input type="text" v-model="editInfo.caseUnit" placeholder="请输入" size="small" clearable class=" inputwidth"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="外出日期：" prop="outDate">
              <el-date-picker size="small" v-model="editInfo.outDate" type="datetime" placeholder="请选择"
                value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" class=" inputwidth"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出院日期：" prop="">
              <el-date-picker size="small" v-model="editInfo.dischargeDate" type="datetime" placeholder="请选择"
                value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" class=" inputwidth"></el-date-picker>
            </el-form-item>
          </el-col>

           <el-col :span="8">
              <el-form-item label="分组" prop="groupType">
                <hic-dict-selector dict-type="PatientGroup" is-enum v-model="editInfo.groupType"
                  placeholder="请选择"></hic-dict-selector>
              </el-form-item>
            </el-col>


          <el-col :span="24">
            <el-form-item label="诊断：" prop="diagnosis">
              <el-input type="textarea" v-model="editInfo.diagnosis" placeholder="请输入" size="small" style="width: 50vw;"
                :rows="2" clearable maxlength="100" :show-word-limit="true"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="外出就诊原因：" prop="outReason">
              <el-input type="textarea" v-model="editInfo.outReason" placeholder="请输入" size="small" style="width: 50vw;"
                :rows="6" clearable maxlength="500" :show-word-limit="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </el-main>
    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" @click="submit" class="left-pad">提交</el-button>
    </template>
  </hic-dialog>
</template>

<script>
import api from './api';
import { mapGetters } from 'sw-hic';
export default {
  components: {},
  props: {
    entity: {
      type: Object,
      default: () => {
        return {};
      },
    },
    patientList: Array,
    visible: Boolean,
    title: String,
  },
  data() {
    return {
      condition: {
        keyword: '',
      },
      detailValue: {},
      meta: {
        loading: false,
        showOper: false,
      },
      editInfo: {

      },
      rules: {
        bedNo: [{ required: true, message: '请选择患者', trigger: 'change' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        outDate: [{ required: true, message: '请选择外出日期', trigger: 'blur' }],        
        diagnosis: [{ required: true, message: '请输入诊断', trigger: 'blur' }],
        outReason: [{ required: true, message: '请输入外出就诊原因', trigger: 'blur' }],
      },

    };
  },
  computed: {
    ...mapGetters(['dict', 'getDict', 'Enum', 'dictEnum', 'user', 'permission']),
  },
  filters: {},
  watch: {},
  mounted() { },
  methods: {
    open() {
      try {
        this.$refs['editInfo'].resetFields()
      } catch (error) {
      }

      this.$set(this, "editInfo", {})
      if (this.title.indexOf('新增') > -1) {
        this.$set(this.editInfo, "outDate", this.$utils.Dt.now())
      } else {
        this.editInfo = this.$utils.Obj.clone(this.entity)
      }

    },
    handlePatientChange(val) {
      let findObj = this.patientList.find(el => el.bedNo == val)
      console.log("--->",findObj)
      
      // this.$set(this.editInfo, "bedNo", findObj.bedNo)
      this.$set(this.editInfo, "name", findObj.patientName || "")
      this.$set(this.editInfo, "ipNo", findObj.ipNo || "")
      this.$set(this.editInfo, "gender", findObj.patientGender || "")
      this.$set(this.editInfo, "age", findObj.patientAge || "")
      this.$set(this.editInfo, "caseUnit", findObj.contactCompany || "")
      this.$set(this.editInfo, "groupType", findObj.groupType || "")

      
    },

    submit() {
      this.$refs['editInfo'].validate((valid) => {
        if (!valid) return
        this.meta.loading = true
        api.OutMedicalRecord.save(this.editInfo)
          .then((res) => {
            this.$emit('ok')
            this.$message.success('提交成功')
            this.cancel()
          })
          .catch((err) => {
            this.$message.error(err || err.message);
          })
          .finally((f) => {
            this.meta.loading = false
          });
      })
    },

    cancel() {
      this.$emit('update:visible', false);
    },
  },
};
</script>

<style scoped>
.inputwidth{
  width: 16rem;
}
.ztitle,
/deep/ .el-collapse-item__header {
  color: #66b1ff;
  font-size: 17px;
}
</style>
